
import { Base } from '../base-component';

import './list-of-links.component.scss';

export class ListOfLinks extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/list-of-links/list-of-links.component.ts